module.exports = __webpack_public_path__ + "static/media/Item 25.1aabb32a.jpg";